__turbopack_context__.v({
  "enhancedAvatarWrapper": "OrganizerInfo-module-scss-module__7kXrya__enhancedAvatarWrapper",
  "enhancedByTag": "OrganizerInfo-module-scss-module__7kXrya__enhancedByTag",
  "enhancedOrganizerInfoContent": "OrganizerInfo-module-scss-module__7kXrya__enhancedOrganizerInfoContent",
  "enhancedOrganizerName": "OrganizerInfo-module-scss-module__7kXrya__enhancedOrganizerName",
  "followButtonWrapper": "OrganizerInfo-module-scss-module__7kXrya__followButtonWrapper",
  "metadataItem": "OrganizerInfo-module-scss-module__7kXrya__metadataItem",
  "metadataRow": "OrganizerInfo-module-scss-module__7kXrya__metadataRow",
  "organizerNameRow": "OrganizerInfo-module-scss-module__7kXrya__organizerNameRow",
  "organizerTextContent": "OrganizerInfo-module-scss-module__7kXrya__organizerTextContent",
  "premiumBadge": "OrganizerInfo-module-scss-module__7kXrya__premiumBadge",
  "premiumNameEnd": "OrganizerInfo-module-scss-module__7kXrya__premiumNameEnd",
  "premiumTooltip": "OrganizerInfo-module-scss-module__7kXrya__premiumTooltip",
  "wrapper": "OrganizerInfo-module-scss-module__7kXrya__wrapper",
});
